<template>
  <div>
    <vue-headful title="Instellingen" />
    <Header page_title="Instellingen" />
    <div class="sd-menu app-body">
      <div>
        <span class="container-fluid sd-title small menu-title">
            <svg-icon icon="smiley" />
            <span class="menu-title-text">Jouw gegevens</span>
        </span>
        <ul class="menu">
          <li class="menu-item personal-details">
            <router-link :to="{name: user.type == 2 ? 'company-profile' : 'applicant-profile'}" class="container-fluid">
              <svg-icon v-if="!user.avatar" icon="person_male" class="profile-img" />
              <span v-else :style="user ? this.ImageBackground($store.state.user_avatar):''" class="profile-img"></span>
              <div class="user-container">
                  <span class="user-name sd-title bold">{{ user.type == 2 ? user.name : user.firstname }}</span>
                  <span class="user-desc">Jouw profiel bekijken</span>
              </div>
              <svg-icon icon="chevron_e" class="menu-item-icon"/>
            </router-link>
          </li>
          <li class="menu-item">
              <router-link :to="{ name: 'applicant-details', params: { action: 'save' } }" class="container-fluid">
                  Persoonsgegevens
                  <svg-icon icon="chevron_e" class="menu-item-icon"/>
              </router-link>
          </li>
          <li class="menu-item">
              <router-link :to="{ name: 'salary-details', params: { action: 'save' } }" class="container-fluid">
                  Verdiensten
                  <svg-icon icon="chevron_e" class="menu-item-icon"/>
              </router-link>
          </li>
          <li class="menu-item">
              <router-link :to="{ name: 'applicant-details', params: { action: 'save' } }" class="container-fluid">
                  Pasfoto aanpassen
                  <svg-icon icon="chevron_e" class="menu-item-icon"/>
              </router-link>
          </li>
          <li class="menu-item" v-if="sub_branch !== '2'">
            <router-link :to="{ name: 'applicant-diplomas' }" class="container-fluid">
              Diploma's & certificaten
              <svg-icon icon="chevron_e" class="menu-item-icon"/>
            </router-link>
          </li>
        </ul>
          <template v-if="branch !== '3'">
                <span class="container-fluid sd-title small menu-title">
                    <svg-icon icon="primary" />
                    <span class="menu-title-text">Basisonderwijs</span>
                </span>
                <ul class="menu">
                  <template v-if="sub_branch.includes('1')">
                    <li class="menu-item">
                      <router-link :to="{ name: 'applicant-step_3', params: { action: 'save', question_branch: '1' } }" class="container-fluid">
                        Opleidingen
                        <svg-icon icon="chevron_e" class="menu-item-icon"/>
                      </router-link>
                    </li>
                    <li class="menu-item">
                      <router-link :to="{ name: 'applicant-step_2', params: { action: 'save', question_branch: '1' } }" class="container-fluid">
                        Ervaring
                        <svg-icon icon="chevron_e" class="menu-item-icon"/>
                      </router-link>
                    </li>
                    </template>
                  <template v-else>
                    <li class="menu-item">
                      <div class="container-fluid warning sd-notif"
                           style="display: flex; justify-content: space-between; align-items: center;">
                        <span style="flex: 1;">Heb je ook interesse om in het basisonderwijs te werken? Wij kunnen dit voor je activeren. Neem
                          <router-link :to="{ name: 'contact' }" class="contact-link">
                            Contact
                          </router-link>
                          op met Derect om de mogelijkheden te bespreken.</span>
                        <a class="btn btn-primary" :href="`https://api.whatsapp.com/send?phone=31850481976`" target="_blank"
                           style="margin-left: 20px; background-color: rgb(255, 205, 0); border-color: rgb(255, 205, 0);">Whatsapp
                          ons</a>
                      </div>
                    </li>

                    <!--            <li class="menu-item">-->
        <!--              <router-link :to="{ name: 'applicant-step_3', params: { action: 'next', question_branch: '1' } }" class="container-fluid warning sd-notif">-->
        <!--                Wil je ook werken in het , vul dan deze vragen in..-->
        <!--                <svg-icon icon="chevron_e" class="menu-item-icon"/>-->
        <!--              </router-link>-->
        <!--            </li>-->
                  </template>
                </ul>
                <span class="container-fluid sd-title small menu-title">
                    <svg-icon icon="secondary" />
                    <span class="menu-title-text">Voortgezet onderwijs</span>
                </span>
                <ul class="menu">
                  <template v-if="sub_branch.includes('2')">
                  <li class="menu-item">
                    <router-link :to="{ name: 'applicant-step_2', params: { action: 'save', question_branch: '2' } }" class="container-fluid">
                      Ervaring
                      <svg-icon icon="chevron_e" class="menu-item-icon"/>
                    </router-link>
                  </li>
                  </template>
                  <template v-else>
                    <li class="menu-item">
                      <div class="container-fluid warning sd-notif"
                           style="display: flex; justify-content: space-between; align-items: center;">
                        <span style="flex: 1;">Heb je ook interesse om in het voortgezet onderwijs te werken? Wij kunnen dit voor je activeren. Neem
                          <router-link :to="{ name: 'contact' }" class="contact-link">
                            contact
                          </router-link>
                          op met Derect om de mogelijkheden te bespreken.</span>
                        <a class="btn btn-primary" :href="`https://api.whatsapp.com/send?phone=31850481976`" target="_blank"
                           style="margin-left: 20px; background-color: rgb(255, 205, 0); border-color: rgb(255, 205, 0);">Whatsapp
                          ons</a>
                      </div>
                    </li>
                  </template>
                </ul>
                <template v-if="sub_branch !== '2'">
                  <span class="container-fluid sd-title small menu-title">
                      <svg-icon icon="file_layout" />
                      <span class="menu-title-text">Documenten</span>
                  </span>
                  <ul class="menu">
                      <li class="menu-item">
                          <router-link :to="{ name: 'applicant-step_1', params: { action: 'save' } }" class="container-fluid">
                              ID/paspoort
                              <svg-icon icon="chevron_e" class="menu-item-icon"/>
                          </router-link>
                      </li>
                      <li class="menu-item">
                          <router-link :to="{ name: 'applicant-step_1', params: { action: 'save' } }" class="container-fluid">
                              VOG certificaat
                              <svg-icon icon="chevron_e" class="menu-item-icon"/>
                          </router-link>
                      </li>
                    <li class="menu-item" v-if="isZzp">
                      <router-link :to="{ name: 'zzpdocs' }" class="container-fluid">
                        ZZP documenten
                        <svg-icon icon="chevron_e" class="menu-item-icon"/>
                      </router-link>
                    </li>
                  </ul>
                </template>
          </template>
          <template v-else>
              <span class="container-fluid sd-title small menu-title">
                    <svg-icon icon="healthcare" />
                    <span class="menu-title-text">Zorg</span>
                </span>
              <ul class="menu">
                  <li class="menu-item">
                    <router-link :to="{ name: 'applicant-step-1-healthcare'}" class="container-fluid">
                      Ervaring
                      <svg-icon icon="chevron_e" class="menu-item-icon"/>
                    </router-link>
                  </li>
              </ul>
          </template>
   </div>
      <span class="container-fluid sd-title small menu-title">
          <svg-icon icon="gear" />
          <span class="menu-title-text">Instellingen</span>
      </span>
      <ul class="menu">
          <li class="menu-item">
              <router-link :to="{name: 'notifications'}" class="container-fluid">
                  Notificaties
                  <svg-icon icon="chevron_e" class="menu-item-icon"/>
              </router-link>
          </li>
          <li class="menu-item">
              <router-link :to="{ name: 'update-password' }" class="container-fluid">
                  Wachtwoord wijzigen
                  <svg-icon icon="chevron_e" class="menu-item-icon"/>
              </router-link>
          </li>
          <li class="menu-item">
              <router-link :to="{ name: 'delete', params: { action: 'save' } }" class="container-fluid">
                  Account verwijderen
                  <svg-icon icon="chevron_e" class="menu-item-icon"/>
              </router-link>
          </li>
      </ul>
      <Footer />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      branch: null,
      sub_branch: null,
      isZzp: false,
      logged_in: this.isUserActiveLoggedIn(),
      route: window.location.href,
      user_token: '',
      user: ''
    };
  },
  async created() {
    this.fetchData();
  },
  watch: {
    navState: async function() {
      await this.fetchData();
    },
    $route: "fetchData"
  },
  async mounted() {
  },
  methods: {
    gotoDashboard() {
      const user = JSON.parse(localStorage.getItem("user"));
      if(user) {
        if(user.type == 1) {
          this.$router.replace({
            name: "applicant-dashboard"
          }).catch(() => {});
        } else {
          this.$router.replace({
            name: "company-dashboard"
          }).catch(() => {});
        }
      } else {
        this.$router.replace({
          name: "login"
        });
      }
    },
    async fetchData() {
      this.branch = localStorage.getItem("branch");
      this.sub_branch = localStorage.getItem('subBranch');
      this.user_token = JSON.parse(localStorage.getItem("user-token"));
      this.user = JSON.parse(localStorage.getItem("user"));

      if(this.user.customer_type == 1) {
          this.isZzp = true;
      }

      if(this.user_token == null)
        this.user_token = "";

      if(this.user == null)
        this.user = "";

      if(this.user)
        this.$store.state.user_avatar = this.user.avatar;
    }
  }
}
</script>

<style scoped>
  .sd-menu {
      position: relative;
      margin-bottom: 40px;
  }

  .sd-title.menu-title {
    display: flex;
    align-items: center;
    margin-top: 40px !important;
    margin-bottom: 20px !important;
    padding: 0 20px;
    line-height: 1;
  }

  .sd-title.menu-title.mini {
    margin-bottom: 0 !important;
  }

  .sd-title.menu-title .menu-title-text {
    margin-top: 3px;
    line-height: 1;
  }

  /deep/ .sd-title.menu-title svg {
    margin-right: 20px;
    height: 20px;
    width: 20px;
    color: #FFCD00;
  }

  .menu {
    list-style: none;
    padding-left: 0;
  }

  .menu .menu-item {
    border-bottom: 1px solid #F4F4F4;
  }

  .menu .menu-item a:not(.contact-link) {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #64513D;
    justify-content: space-between;
    padding: 20px;
  }

  /deep/ .menu .menu-item .warning {
    margin-bottom: 15px !important;
  }

  /deep/ .menu .menu-item a .menu-item-icon svg {
    height: 12px;
  }

  .menu .menu-item.personal-details {
    padding-top: 0;
    padding-bottom: 10px;
    border-bottom: 0;
  }

  .menu .menu-item.personal-details a {
    display: block;
    border: 1px solid #F4F4F4;
    padding: 10px 20px;
    border-radius: 10px;
  }

  .menu .menu-item.personal-details a {
    display: grid;
    align-items: center;
    grid-template-columns: 40px 1fr 10px;
  }

  .menu .menu-item.personal-details .profile-img {
    display: block;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    background-size: cover;
  }

  .menu .menu-item.personal-details .user-name {
      display: block;
      font-size: 14px;
  }

  .menu .menu-item.personal-details .user-desc {
      display: block;
      font-size: 14px;
  }

  @media screen and (max-width: 768px) {
      .sd-title.menu-title {
          padding: 0 20px;
      }
  }
</style>
